
<div *ngIf="data.status==Rejected">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Reject</h3>
    </div>

    <div class="dds__modal-body">
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080" >Add comments <sup style="color: red;">*</sup></label>
              <textarea  [(ngModel)]="data.comment"  id="disabledTextInput" class="dds__form-control" ></textarea>
          </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button [disabled]="!data.comment" class="dds__btn dds__form-check-inline dds__btn-primary"  [mat-dialog-close]="{click:true,comment:data.comment}"  cdkFocusInitial>Reject</button>
    </div>
  </div>
</div>

<div *ngIf="data.status==Deleted">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Restore</h3>
    </div>

    <div class="dds__modal-body">
      <div class="dds__form-group">
        <label for="disabledTextInput" style="color:#808080">File Name <sup style="color: red;">*</sup></label>
        <!-- <textarea  [(ngModel)]="data.comment"  id="disabledTextInput" class="dds__form-control" ></textarea>-->
        <input type="text" [(ngModel)]="data.folder"
               id="disabledTextInput" class="dds__form-control">

        <!--<div>Folder name already taken. Please change the name to proceed</div>-->
      </div>
      <div class="dds__form-group errortext">
        <label for="disabledTextInput" style="color: red;" >{{data.duplictatefileNameMessage}}</label>

      </div>
      <div class="dds__modal-footer">
        <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
        <button [disabled]="!data.folder" class="dds__btn dds__btn-purchase dds__form-check-inline " [mat-dialog-close]="{click:true,folder:data.folder}" cdkFocusInitial>Restore</button>
      </div>
    </div>

  </div>
</div>
<div *ngIf="data.status==Published">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Approve</h3>
    </div>

    <div class="dds__modal-body">
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080" >Add comments [Optional]</label>
              <textarea [(ngModel)]="data.comment"  id="disabledTextInput" class="dds__form-control" ></textarea>
          </div>
    </div>
    <div style="color: #f2af00;width: 300px;" *ngIf="data.startDateError">{{data.startDateError}}</div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-purchase dds__form-check-inline " [mat-dialog-close]="{click:true,comment:data.comment}" cdkFocusInitial>Approve</button>
    </div>
  </div>

</div>

